import { CSSResultGroup, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { html } from 'lit/static-html.js';

import defaultVars from '../sic-chip/css-variables/vars-default.css.lit';

/**
 * The Label component.
 * @element sic-label
 * @slot defaultSlot
 *
 * Lightdom styles in sic-label.lightdom.css included in /shared.css
 */
@customElement('sic-label')
export class SicLabel extends OutlineElement {
  static styles: CSSResultGroup = [defaultVars];

  render(): TemplateResult {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sic-label': SicLabel;
  }
}
